module.exports = __webpack_public_path__ + "img/68.4a1afe5c.jpg";